import { HeaderIcon, NaviIconSearch } from '@banhala/ui-kit';
import { bridge, useNavigator } from 'shared/src/utils';
import { useGetScreensInfiniteQuery } from './hooks/useGetScreensInfiniteQuery';
import type { AnyObject } from 'shared/src/types';

export const SearchIcon = () => {
  const { navigator } = useNavigator();
  const { data } = useGetScreensInfiniteQuery();

  const handleSearchClick = () => {
    logClickSearch(data?.logging);
    navigator.moveToSearch();
  };

  return (
    <HeaderIcon onPress={handleSearchClick}>
      <NaviIconSearch />
    </HeaderIcon>
  );
};

const logClickSearch = (logging: AnyObject | undefined) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_SEARCH',
    analytics: logging?.analytics,
    ably_only_log: logging?.ably_only_log,
  });
};
